import Builder from "../../utils/redux/builder";
import {newsList} from "../../constants/copyright";
import {addLike, addView, createComment, getAuthors, getComments, getMoreArticles, getSearch} from "../../api/app";
import {getNextState} from "../../constants/form-states";

const builder = new Builder({
  name: "panel",
  initialState: {
    preloader:false,
    padding:false,
    receivedData: [],
    authorData: undefined,
    commentsInfo: undefined,
    page: "intro",
    filter: "",
    isLogin: true,
    burger: false,
    activeStoryId: null,
    offsetTop: 0,
    form: "start"
    // filters:[]
  },
  reducers: {
    changeIsLogin(state, {payload}) {
      state.isLogin = payload;
    },
    changeBurger(state, {payload}) {
      state.burger = payload;
    },
    changeOffsetTop(state, {payload}) {
      state.offsetTop = payload
    },
    changeActiveStoryId(state, {payload}) {
      state.activeStoryId = payload
    },
    resetStoryId(state) {
      state.activeStoryId = null
    },
    changeFilter(state, {payload}) {
      state.filter = payload;
    },
    changePreloader(state,{payload}){
      state.preloader = payload
    },
    addData(state, {payload}) {
      // console.log(payload,'DATA')
      state.receivedData = payload;
    },
    addAuthorData(state, {payload}) {
      state.authorData = payload
    },
    pushNewData(state) {
      state.receivedData = state.receivedData.concat(newsList)
    },
    addInfo(state, {payload}) {
      state.commentsInfo = payload
    },
    requestFormState(state, action) {
      console.log('action.payload=========>', action.payload)
      state.form = getNextState(action.payload, state);
    },
  }
}).createExtraReducer({
  thunkName: 'panel/getMoreArticles',
  thunkExtraName: 'getMoreArticles',
  onSubmit() {
    console.log('...')
  },
  saveError() {
    console.log('ERRR')
  },
  saveData(state, {payload}) {
    state.receivedData = state.receivedData.concat(payload.items)
  },
  func: getMoreArticles
}).createExtraReducer({
  thunkName: 'panel/createComment',
  thunkExtraName: 'createComment',
  onSubmit() {
    console.log('...')
  },
  saveError() {
    console.log('ERRR')
  },
  saveData(state, {payload}) {
    state.commentsInfo = payload
  },
  func: async (data) => {
    await createComment(data);
    const comments = getComments(data)
    return comments;
  }
}).createExtraReducer({
  thunkName: 'panel/getCommentsToPage',
  thunkExtraName: 'getCommentsToPage',
  onSubmit() {
    console.log('...')
  },
  saveError() {
    console.log('ERRR')
  },
  saveData(state, {payload}) {
    state.commentsInfo = payload
  },
  func: getComments
}).createExtraReducer({
  thunkName: 'panel/addLike',
  thunkExtraName: 'addLike',
  saveData(state, {payload}) {
    state.commentsInfo = {
      ...state.commentsInfo,
      items: state.commentsInfo.items.map((comment) => comment.id === payload.comment.id ? payload.comment : comment)
    }
  },
  func: addLike
}).createExtraReducer({
  thunkName: 'panel/addView',
  thunkExtraName: 'addView',
  saveData(state, {payload:{content:{views_count}}}){
    state.viewsCount = views_count
  },
  func: addView
}).createExtraReducer({
  thunkName: 'panel/getMoreSearchItems',
  thunkExtraName: 'getMoreSearchItems',
  onSubmit(state){
    state.padding = true
  },
  saveData(state, {payload}) {
    state.receivedData = state.receivedData.concat(payload.items)
    state.padding = false
  },
  func: getSearch
}).createExtraReducer({
  thunkName: 'panel/getAuthorFilter',
  thunkExtraName: 'getAuthorFilter',
  saveData(state, {payload}) {
    state.authorData = payload;
  },
  func: getAuthors
})

builder.create();

const panel = builder.export();
export default panel;

export const {
  changeFilter, addData, pushNewData, addInfo,
  changeOffsetTop, changeBurger, changeIsLogin,
  resetStoryId, changeActiveStoryId, requestFormState, addAuthorData,
  changePreloader
} = panel.actions;
export const {usePanel} = panel.selectors;
